import { useContext } from "react";
import { useMutation, useQueryClient } from "react-query";
import { ToastContext } from "../../../hooks/context";
import { deleteExpenseCategory } from "../../../services/expenses";

const useExpensCategoryDeletion = ({
  categoryDetails,

  closeWidget,
}) => {
  const triggerToast = useContext(ToastContext);
  const queryClient = useQueryClient();
  const { mutate: deleteCategory, isLoading: isDeletingCategory } = useMutation(
    (data) => deleteExpenseCategory(data),
  );
  const handleDeleteExpenseCategory = () => {
    deleteCategory(
      {
        id: categoryDetails?.id,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(["getExpenseCategories"]);
          triggerToast("Category Deleted successfully", "success");
          closeWidget();
        },
      },
    );
  };

  return {
    isDeletingCategory,
    handleDeleteExpenseCategory,
  };
};
export default useExpensCategoryDeletion;
